import { GET_EXPERT, GET_EXPERT_BY_ID } from "../constants/index";

export const experts = (state = { expertlist: [], expertbyid: {} }, action) => {
  switch (action.type) {
    case GET_EXPERT:
      return { ...state, expertlist: action.expertlist };
    case GET_EXPERT_BY_ID:
      return { ...state, expertbyid: action.expertbyid };
    default:
      return state;
  }
};
